import { render } from "./Opportunity.vue?vue&type=template&id=6b1f72e1&scoped=true"
import script from "./Opportunity.vue?vue&type=script&lang=js"
export * from "./Opportunity.vue?vue&type=script&lang=js"

import "./Opportunity.vue?vue&type=style&index=0&id=6b1f72e1&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1f72e1"]])

export default __exports__